<div class="mb-10 flex flex-col font-sans text-xl">
  @if (type === 'textarea') {
    <label [for]="inputElement">{{ label }}<span *ngIf="required"> *</span></label>
    <div class="flex flex-row">
      <textarea class="h-[3lh] min-h-[2lh] w-full resize-y text-2xl outline-none border-solid border-[1px] rounded-sm border-[rgba(0, 21, 74, 0.4)]" #inputElement></textarea>
    </div>
  } @else if (type === 'phone') {
    <label [for]="inputElement">{{ label }}<span *ngIf="required"> *</span></label>
    <div class="flex flex-row">
      <input
        [type]="type"
        [formControl]="formControl"
        [required]="required"
        [attr.aria-required]="required"
        [attr.aria-label]="ariaLabel"
        [placeholder]="placeholder"
        [autocomplete]="autocomplete"
        [readonly]="readOnly"
        class="border-none text-2xl outline-none"
        (keydown.enter)="onKeydownEnter()"
        mask="(000) 000 - 0000 x 999999"
        [specialCharacters]="['x', '-', '(', ')', ' ']"
        #inputElement
      />
      <mat-icon *ngIf="readOnly" class="h-[1.5lh]" matSuffix>lock</mat-icon>
    </div>
  } @else {
    <label [for]="inputElement">{{ label }}<span *ngIf="required"> *</span></label>
    <div class="flex flex-row">
      <input
        [type]="type"
        [formControl]="formControl"
        [required]="required"
        [attr.aria-required]="required"
        [attr.aria-label]="ariaLabel"
        [placeholder]="placeholder"
        [autocomplete]="autocomplete"
        [readonly]="readOnly"
        class="border-none text-2xl outline-none"
        (keydown.enter)="onKeydownEnter()"
        #inputElement
      />
      <mat-icon *ngIf="readOnly" class="h-[1.5lh]" matSuffix>lock</mat-icon>
    </div>
  }
  <mat-error class="min-h-[1lh]">
    <app-boomer-forms-errors class="text-xl text-red-800" [control]="formControl"></app-boomer-forms-errors>
  </mat-error>
</div>
